// extracted by mini-css-extract-plugin
export default {"video_container":"Home_video_container__0I3-C","ar_video_container":"Home_ar_video_container__K-dYN","overlay":"Home_overlay__jNxXJ","text_container":"Home_text_container__8GH6i"};